// TaskList.js

import React from 'react';

function TaskList({ tasks, toggleTaskCompletion }) {
  return (
    <div className="task-list-wrapper">
      <div className="task-list">
        {tasks.map((task) => (
          <div key={task.id} className={`task-item ${task.completed ? 'completed' : ''}`}>
            <input
              type="checkbox"
              checked={task.completed}
              onChange={() => toggleTaskCompletion(task.id)}
            />
            <div className="task-text">{task.text}</div>
            <div className="task-pomodoros">
              {task.usedPomodoros}/{task.estimatedPomodoros} Sessions
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TaskList;
